var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.53 10.53a.75.75 0 1 0-1.06-1.06l1.06 1.06ZM12 14l-.53.53a.75.75 0 0 0 1.06 0L12 14ZM8.53 9.47a.75.75 0 0 0-1.06 1.06l1.06-1.06Zm6.94 0-4 4 1.06 1.06 4-4-1.06-1.06Zm-2.94 4-4-4-1.06 1.06 4 4 1.06-1.06Z","fill":"currentColor"}));
}

ChevronDown.defaultProps = {"id":"chevron_down","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
